import { PointNPayPaymentAccountActivityConfiguration } from './pointnpay-payment-account-activity-configuration';
import { PaymentProcessorAccountConfigurationBase } from '../payment-processor-account-configuration-base';

export class PointNPayPaymentProcessorAccountConfiguration extends PaymentProcessorAccountConfigurationBase {
  productId: string;
  clientCode: string;
  parameterNames: string[];
  activityConfiguration: PointNPayPaymentAccountActivityConfiguration;

  constructor(
    options?: Partial<PointNPayPaymentProcessorAccountConfiguration>
  ) {
    super(options);

    if (options) {
      Object.assign(this, options);
    }
  }
}
